module.exports = __webpack_public_path__ + "img/logo.658bebab.png";